import { useMemo, useState } from "react";
import { handleClickColor, timezones } from "../../Common/Util";
import { Dropdown, DropdownButton } from "react-bootstrap";

export function RashiChart ({birthHouseData,userData,clientData,birthChartType,setBirthChartType,kpenabled}) {
  const [showDegree, setShowDegree] = useState(false);
  const [showCuspal, setShowCuspal] = useState(false);
  const [showPlanet, setShowPlanet] = useState(true);
  const [showHouse, setShowHouse] = useState(true);

  const chartType = ['South India','North India','East India','Bhava Chalit'];
  const firstrowloop = [11,0,1,2];
  const secondrowloop = [10,3];
  const thirdrowloop = [9,4];
  const lastrowloop = [8,7,6,5];
  const handleDegreeVisible = ()=>setShowDegree(!showDegree);
  const handleCuspalVisible = ()=>setShowCuspal(!showCuspal);
  const handlePlanetVisible = ()=>setShowPlanet(!showPlanet);
  const handleHouseVisible = ()=>setShowHouse(!showHouse);
  const trheight = {height: "12vh"};
  const nrheight = {height: "27vh"};
  const ertableheight = {height: "50vh"};
  const erratio1="60%";
  const erratio2="40%";

  useMemo(() => {
    if(birthChartType==='0' && kpenabled===true) {
      setShowDegree(true);
      setShowCuspal(true);
    } else {
      if(birthChartType==='3') {
        setShowDegree(false);
        setShowCuspal(true);
      } else {
        setShowDegree(false);
        setShowCuspal(false);
      }
    }
  },[birthChartType,kpenabled])

  function getPlanets(index) {
    return birthHouseData[(12-birthHouseData[0].cuspalNumber+index)%12].list.map((planet) => (
      <>
        {
          (planet.label.length<3 || planet.label.includes("I") || planet.label.includes("ASC"))?
          (showCuspal?<>{planet.label} {birthChartType==='3'?(planet.sign+" "+planet.relDegree.substring(0,5)):(showDegree && planet.relDegree)} {planet.retro}<br/></>:<></>)
          :
          (showPlanet?<>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>:<></>)
        }
      </>
    ));
  }

  function getNorthHouse(index) {
    return showHouse?birthHouseData[(12-birthHouseData[0].cuspalNumber+index)%12].houseNumber:<>&nbsp;</>;
  }

  function getEastHouse(index) {
    return showHouse?birthHouseData[(12-birthHouseData[0].cuspalNumber+index)%12].houseNumber:"";
  }

  return(
    <>
    <table class="m-0 p-0 table">
      <caption class="m-0 p-0" >
        <table class="m-0 p-0"><tbody><tr class="m-0 p-0"><td class="m-0 p-0"><h4 class="m-0 p-0 pt-1 pb-1">Rashi Chart</h4></td><td class="m-0 p-0">
        <DropdownButton id="dropdown-basic-button" title={chartType[birthChartType]} variant="transparent" class="m-0 p-0 pt-1 border-1">
          <Dropdown.Item onClick={()=>setBirthChartType('0')} >South India</Dropdown.Item>
          <Dropdown.Item onClick={()=>setBirthChartType('1')} >North India</Dropdown.Item>
          <Dropdown.Item onClick={()=>setBirthChartType('2')} >East India</Dropdown.Item>
          <Dropdown.Item onClick={()=>setBirthChartType('3')} >Bhava chalit</Dropdown.Item>
        </DropdownButton></td></tr></tbody></table>
      </caption>
    </table>
    {birthChartType==='1'||birthChartType==='3'?
    <>
    <div class="m-0 p-0 container">
      <div class="m-0 p-0 position-relative">
        <table class="m-0 p-0 table table-borderless position-absolute w-100 h-100">
          <tbody class="m-0 p-0">
            <tr class="m-0 p-0 h-25">
              <td class="m-0 p-0 pt-1 text-center align-top w-50 bg-transparent">{getPlanets(1)}</td>
              <td class="m-0 p-0 pt-1 text-center align-top w-50 bg-transparent">{getPlanets(11)}</td>
            </tr>
            <tr class="m-0 p-0 h-50">
              <td class="m-0 p-0 text-center align-middle w-50 bg-transparent">{getPlanets(3)}</td>
              <td class="m-0 p-0 text-center align-middle w-50 bg-transparent">{getPlanets(9)}</td>
            </tr>
            <tr class="m-0 p-0 h-25">
              <td class="m-0 p-0 pb-1 text-center align-bottom w-50 bg-transparent">{getPlanets(5)}</td>
              <td class="m-0 p-0 pb-1 text-center align-bottom w-50 bg-transparent">{getPlanets(7)}</td>
            </tr>
          </tbody>
        </table>
        <table class="m-0 p-0 table table-borderless position-absolute w-100 h-100">
          <tbody class="m-0 p-0">
            <tr class="m-0 p-0 h-50">
              <td class="m-0 p-0 ps-2 text-start align-middle w-25 bg-transparent">{getPlanets(2)}</td>
              <td class="m-0 p-0      text-center align-middle w-50 bg-transparent">{getPlanets(0)}</td>
              <td class="m-0 p-0 pe-2 text-end align-middle w-25 bg-transparent">{getPlanets(10)}</td>
            </tr>
            <tr class="m-0 p-0 h-50">
              <td class="m-0 p-0 ps-2 text-start align-middle w-25 bg-transparent">{getPlanets(4)}</td>
              <td class="m-0 p-0      text-center align-middle w-50 bg-transparent">{getPlanets(6)}</td>
              <td class="m-0 p-0 pe-2 text-end align-middle w-25 bg-transparent">{getPlanets(8)}</td>
            </tr>
          </tbody>
        </table>
        <table class="m-0 p-0 table table-borderless position-absolute w-100 h-100">
          <tbody class="m-0 p-0">
            <tr class="m-0 p-0"  >
              <td class="m-0 p-0 pb-2 text-center align-bottom w-50 bg-transparent">{getNorthHouse(1)}</td>
              <td class="m-0 p-0 pb-2 text-center align-bottom w-50 bg-transparent">{getNorthHouse(11)}</td>
            </tr>
            <tr class="m-0 p-0"  >
              <td class="m-0 p-0 pb-2 text-center align-bottom bg-transparent" colSpan="2">{getNorthHouse(0)}</td>
            </tr>
            <tr class="m-0 p-0"  >
              <td class="m-0 p-0 pt-2 text-center align-top bg-transparent" colSpan="2">{getNorthHouse(6)}</td>
            </tr>
            <tr class="m-0 p-0" >
              <td class="m-0 p-0 pt-2 text-center align-top bg-transparent">{getNorthHouse(5)}</td>
              <td class="m-0 p-0 pt-2 text-center align-top bg-transparent">{getNorthHouse(7)}</td>
            </tr>
          </tbody>
        </table>
        <table class="m-0 p-0 table table-borderless position-absolute w-100 h-100">
          <tbody class="m-0 p-0">
            <tr class="m-0 p-0"  >
              <td class="m-0 p-0 pe-3 text-end align-middle w-25 bg-transparent">{getNorthHouse(2)}</td>
              <td class="m-0 p-0 pe-3 text-end align-middle w-25 bg-transparent" rowSpan="2">{getNorthHouse(3)}</td>
              <td class="m-0 p-0 ps-3 text-start align-middle w-25 bg-transparent" rowSpan="2">{getNorthHouse(9)}</td>
              <td class="m-0 p-0 ps-3 text-start align-middle w-25 bg-transparent">{getNorthHouse(10)}</td>
            </tr>
            <tr class="m-0 p-0"  >
              <td class="m-0 p-0 pe-3 text-end align-middle w-25 bg-transparent">{getNorthHouse(4)}</td>
              <td class="m-0 p-0 ps-3 text-start align-middle w-25 bg-transparent">{getNorthHouse(8)}</td>
            </tr>
          </tbody>
        </table>
        <table class="m-0 p-0 table table-borderless position-relative w-100">
          <tbody class="m-0 p-0">
            <tr class="m-0 p-0"  style={nrheight}>
              <td class="m-0 p-0 border-start border-top border-primary diagonal bg-transparent"></td>
              <td class="m-0 p-0 border-end border-top border-primary diagonal bg-transparent"></td>
            </tr>
            <tr class="m-0 p-0" style={nrheight}>
              <td class="m-0 p-0 border-start border-bottom border-primary diagonal bg-transparent"></td>
              <td class="m-0 p-0 border-end border-bottom border-primary diagonal bg-transparent"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </>
    :<>
    {birthChartType==='2'?
    <>
    <div class="m-0 p-0 container">
      <div class="m-0 p-0 position-relative">
        <table class="m-0 p-0 table table-bordered position-absolute w-100" style={ertableheight}>
          <tbody class="m-0 p-0 w-100 h-100">
            <tr class="m-0 p-0" height="33%">
              <td class="m-0 p-0 pe-1 pt-1 bg-transparent text-end align-top" width="33%">{getPlanets(1)}</td>
              <td class="m-0 p-0 bg-transparent" width="34%"></td>
              <td class="m-0 p-0 ps-1 pt-1 bg-transparent text-start align-top" width="33%">{getPlanets(11)}</td>
            </tr>
            <tr class="m-0 p-0" height="34%">
              <td class="m-0 p-0 bg-transparent" width="33%"></td>
              <td class="m-0 p-0 bg-transparent" width="34%"></td>
              <td class="m-0 p-0 bg-transparent" width="33%"></td>
            </tr>
            <tr class="m-0 p-0" height="33%">
              <td class="m-0 p-0 pe-1 pb-1 bg-transparent text-end align-bottom" width="33%">{getPlanets(5)}</td>
              <td class="m-0 p-0 bg-transparent" width="34%"></td>
              <td class="m-0 p-0 ps-1 pb-1 bg-transparent text-start align-bottom" width="33%">{getPlanets(7)}</td>
            </tr>
          </tbody>
        </table>
        <table class="m-0 p-0 table table-bordered position-absolute w-100" style={ertableheight}>
          <tbody class="m-0 p-0 w-100 h-100">
            <tr class="m-0 p-0" height="33%">
              <td class="m-0 p-0 ps-1 pb-1 bg-transparent text-start align-bottom" width="33%">{getPlanets(2)}</td>
              <td class="m-0 p-0 bg-transparent" width="34%"></td>
              <td class="m-0 p-0 pe-1 pb-1 bg-transparent text-end align-bottom" width="33%">{getPlanets(10)}</td>
            </tr>
            <tr class="m-0 p-0" height="34%">
              <td class="m-0 p-0 bg-transparent" width="33%"></td>
              <td class="m-0 p-0 bg-transparent" width="34%"></td>
              <td class="m-0 p-0 bg-transparent" width="33%"></td>
            </tr>
            <tr class="m-0 p-0" height="33%">
              <td class="m-0 p-0 ps-1 pt-1 bg-transparent text-start align-top" width="33%">{getPlanets(4)}</td>
              <td class="m-0 p-0 bg-transparent" width="34%"></td>
              <td class="m-0 p-0 pe-1 pt-1 bg-transparent text-end align-top" width="33%">{getPlanets(8)}</td>
            </tr>
          </tbody>
        </table>
        <table class="m-0 p-0 table table-borderless position-relative w-100" style={ertableheight}>
          <tbody class="m-0 p-0 w-100 h-100">
            <tr class="m-0 p-0" height="33%">
              <td class="m-0 p-0 border border-primary bg-transparent leftdiagonal" width="33%">
                <table class="m-0 p-0 w-100 h-100"  border="0">
                  <tr class="m-0 p-0" height={erratio1}><td class="m-0 p-0" width={erratio1}></td><td class="m-0 p-0" width={erratio2}></td></tr>
                  <tr class="m-0 p-0" height={erratio2}><td class="m-0 p-0" width={erratio1}></td><td class="m-0 p-0" width={erratio2}>
                    <table class="m-0 p-0 w-100 h-100"  border="0">
                      <tr class="m-0 p-0 h-50"><td class="m-0 p-0 pe-1 pt-1 w-100 text-end align-top">{getEastHouse(1)}</td></tr>
                      <tr class="m-0 p-0 h-50"><td class="m-0 p-0 ps-1 pb-1 w-100 text-start align-bottom">{getEastHouse(2)}</td></tr>
                    </table>
                  </td></tr>
                </table>
              </td>
              <td class="m-0 p-0 border border-primary bg-transparent" width="34%">
                <table class="m-0 p-0 w-100 h-100"  border="0">
                  <tr class="m-0 p-0" height={erratio1}><td class="m-0 p-0 pt-1 text-center align-top" width="100%">{getPlanets(0)}</td></tr>
                  <tr class="m-0 p-0" height={erratio2}><td class="m-0 p-0 text-center align-top" width="100%">{getEastHouse(0)}</td></tr>
                </table>
              </td>
              <td class="m-0 p-0 border border-primary rightdiagonal bg-transparent" width="33%">
                <table class="m-0 p-0 w-100 h-100"  border="0">
                  <tr class="m-0 p-0" height={erratio1}><td class="m-0 p-0" width={erratio2}></td><td class="m-0 p-0" width={erratio1}></td></tr>
                  <tr class="m-0 p-0" height={erratio2}><td class="m-0 p-0" width={erratio2}>
                    <table class="m-0 p-0 w-100 h-100"  border="0">
                      <tr class="m-0 p-0 h-50"><td class="m-0 p-0 ps-1 pt-1 w-100 text-start align-top">{getEastHouse(11)}</td></tr>
                      <tr class="m-0 p-0 h-50"><td class="m-0 p-0 pe-1 pb-1 w-100 text-end align-bottom">{getEastHouse(10)}</td></tr>
                    </table>
                  </td><td class="m-0 p-0" width={erratio1}></td></tr>
                </table>
              </td>
            </tr>
            <tr class="m-0 p-0" height="34%" >
              <td class="m-0 p-0 border border-primary bg-transparent">
                <table class="m-0 p-0 w-100 h-100"  border="0">
                  <tr class="m-0 p-0 h-100">
                    <td class="m-0 p-0 ps-1 text-start align-middle" width={erratio1}>{getPlanets(3)}</td>
                    <td class="m-0 p-0 text-start align-middle" width={erratio2}>{getEastHouse(3)}</td>
                  </tr>
                </table>
              </td>
              <td class="m-0 p-0 border border-primary bg-transparent"></td>
              <td class="m-0 p-0 border border-primary bg-transparent">
                <table class="m-0 p-0 w-100 h-100"  border="0">
                  <tr class="m-0 p-0 h-100">
                    <td class="m-0 p-0 text-end align-middle" width={erratio2}>{getEastHouse(9)}</td>
                    <td class="m-0 p-0 pe-1 text-end align-middle" width={erratio1}>{getPlanets(9)}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr class="m-0 p-0" height="33%" >
              <td class="m-0 p-0 border border-primary rightdiagonal bg-transparent">
                <table class="m-0 p-0 w-100 h-100"  border="0">
                  <tr class="m-0 p-0" height={erratio2}><td class="m-0 p-0" width={erratio1}></td><td class="m-0 p-0" width={erratio2}>
                    <table class="m-0 p-0 w-100 h-100"  border="0">
                      <tr class="m-0 p-0 h-50"><td class="m-0 p-0 ps-1 pt-1 w-100 text-start align-top">{getEastHouse(4)}</td></tr>
                      <tr class="m-0 p-0 h-50"><td class="m-0 p-0 pe-1 pb-1 w-100 text-end align-bottom">{getEastHouse(5)}</td></tr>
                    </table>
                  </td></tr>
                  <tr class="m-0 p-0" height={erratio1}><td class="m-0 p-0" width={erratio1}></td><td class="m-0 p-0" width={erratio2}></td></tr>
                </table>
              </td>
              <td class="m-0 p-0 border border-primary bg-transparent">
                <table class="m-0 p-0 w-100 h-100"  border="0">
                  <tr class="m-0 p-0" height={erratio2}><td class="m-0 p-0 text-center align-bottom" width="100%">{getEastHouse(6)}</td></tr>
                  <tr class="m-0 p-0" height={erratio1}><td class="m-0 p-0 pb-1 text-center align-bottom" width="100%">{getPlanets(6)}</td></tr>
                </table>
              </td>
              <td class="m-0 p-0 border border-primary leftdiagonal bg-transparent">
                <table class="m-0 p-0 w-100 h-100"  border="0">
                  <tr class="m-0 p-0" height={erratio2}><td class="m-0 p-0" width={erratio2}>
                    <table class="m-0 p-0 w-100 h-100"  border="0">
                      <tr class="m-0 p-0 h-50"><td class="m-0 p-0 pe-1 pt-1 w-100 text-end align-top">{getEastHouse(8)}</td></tr>
                      <tr class="m-0 p-0 h-50"><td class="m-0 p-0 ps-1 pb-1 w-100 text-start align-bottom">{getEastHouse(7)}</td></tr>
                    </table>
                  </td><td class="m-0 p-0" width={erratio1}></td></tr>
                  <tr class="m-0 p-0" height={erratio1}><td class="m-0 p-0" width={erratio2}></td><td class="m-0 p-0" width={erratio1}></td></tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </>
    :
    <table class="m-0 p-0 table align-middle text-center">
      <tbody class="m-0 p-0">
        <tr class="m-0 p-0" style={trheight}>
        {firstrowloop.map((firstrowcol) => (
          <td class="m-0 p-0 border border-1 border-primary w-25" onClick={handleClickColor}>
          {birthHouseData[firstrowcol].list.map((planet) => (
            <>
              {!showCuspal&&(planet.label.length<3 || planet.label.includes("I"))?<></>:
                <>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>
              }
            </>  
          ))}
          </td>
        ))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {secondrowloop.map((secondrowcol,colindex) => (
        <>
          <td class="m-0 p-0 border border-1 border-primary" onClick={handleClickColor}>
          {birthHouseData[secondrowcol].list.map((planet) => (
            <>
              {!showCuspal&&(planet.label.length<3 || planet.label.includes("I"))?<></>:
                <>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>
              }
            </>  
          ))}
          </td>
          {colindex!==0?<></>:
          <td class="m-0 p-0 text-center border-primary" colSpan="2" rowSpan="2">
            <b>RASHI CHART</b><br/>
            <br/>{userData.firstName+" "+userData.lastName}
            <br/>{userData.birthDate} {userData.birthDay} 
            <br/>{userData.birthTimeCorrected===null?userData.birthTime:userData.birthTimeCorrected} {timezones.find(tz => tz.value === userData.birthTimezone).label.substring(1,10)}
            <br/>{userData.birthCity}
            <br/>Lat:{userData.birthLatitude} Lon:{userData.birthLongitude}
            <br/>{clientData.ayanamsaName} : {clientData.ayanamsaDegree}
          </td>}
        </>))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {thirdrowloop.map((thirdrowcol) => (
          <td class="m-0 p-0 border border-1 border-primary" onClick={handleClickColor}>
          {birthHouseData[thirdrowcol].list.map((planet) => (
          <>
            {!showCuspal&&(planet.label.length<3 || planet.label.includes("I"))?<></>:
              <>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>
            }
          </>  
          ))}
          </td>
          ))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {lastrowloop.map((lastrowcol) => (
          <td class="border border-1 p-0 border-primary" onClick={handleClickColor}>
          {birthHouseData[lastrowcol].list.map((planet) => (
          <>
            {!showCuspal&&(planet.label.length<3 || planet.label.includes("I"))?<></>:
              <>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>
            }
          </>
          ))}
          </td>
        ))}
        </tr>  
      </tbody>
    </table>
    }
    </>
    }
    <table class="m-0 p-0 table table-borderless align-middle text-center noprint">
    <tbody class="m-0 p-0">
      <tr class="m-0 p-0" >
        <td class="m-0 p-2"></td>
        {birthChartType==='2' || birthChartType==='1'?
        <>
          <td class="m-0 p-2"><button type="button" class="btn btn-outline-primary" onClick={handleHouseVisible}>{showHouse?"Hide":"Show"} House</button></td>
          <td class="m-0 p-2"><button type="button" class="btn btn-outline-primary" onClick={handlePlanetVisible}>{showPlanet?"Hide":"Show"} Planet</button></td>
        </>
          :
        <td class="m-0 p-2"><button type="button" class="btn btn-outline-primary" onClick={handleDegreeVisible}>{showDegree?"Hide":"Show"} Degree</button></td>
        }
        <td class="m-0 p-2"><button type="button" class="btn btn-outline-primary" onClick={handleCuspalVisible}>{showCuspal?"Hide":"Show"} Cuspal</button></td>
        <td class="m-0 p-2"></td>
      </tr>
    </tbody>
    </table>

    <span class="m-0 p-0">
        (R) - Retro Planet<br/>
        @ - Planets in self star<br/>
        * - Planet is not acting as Star Lord of any planet<br/>
    </span>
    </>
  );
}

